/* eslint-disable jsx-a11y/no-distracting-elements */
import "./sidebarcustomization.css";
import {
  React,
  memo,
  Button,
  toast,
  useState,
  Box,
  useGetCountriesMutation,
  useGetWeatherMutation,
  FileUploader,
  Modal,
  Switch,
  FormControlLabel,
  useUpdateCustomizationMutation,
  FormLabel,
  FormControl,
  FormGroup,
  Radio,
  RadioGroup,
  SketchPicker,
  reactCSS,
  Select,
  Checkbox,
  GetCookie,
  Divider,
  BASEURL,
} from "../../../Libraries/Post/Customization/index";
import { json } from "react-router-dom";
import { useGetNewsFromSourcesMutation } from "../../../Redux/service/AllEmpData";
import { useGetRSSNewsSourcesMutation } from "../../../Redux/service/AllEmpData";

const fileTypes = ["PNG"];

const ScreenSidebarCustomization = (props) => {
  const [updatecustomization] = useUpdateCustomizationMutation();
  const [getNewsSources] = useGetNewsFromSourcesMutation();
  const [getRSSNewsSources] = useGetRSSNewsSourcesMutation();

  const [cities, { isLoading }] = useGetCountriesMutation();
  const [Weather] = useGetWeatherMutation();

  const [newsFromSources, setNewsFromSources] = useState();
  const [rssNewsFromLink, setRssNewsFromLink] = useState();

  const [cityvalue, setcityvalue] = useState(
    props?.AllCustomization?.sidebar_header_widget_weather_stats !== null &&
      props?.AllCustomization?.sidebar_header_widget_weather_stats !== "N/A"
      ? props?.AllCustomization?.sidebar_header_widget_weather_stats?.value
      : ""
  );

  const [citylist, setcitylist] = useState([]);
  // sidebar_header_widget_weather_stats
  const [selectedcity, setselectedcity] = useState(
    props?.AllCustomization?.sidebar_header_widget_weather_stats !== null &&
      props?.AllCustomization?.sidebar_header_widget_weather_stats !== "N/A"
      ? props?.AllCustomization?.sidebar_header_widget_weather_stats
      : []
  );
  // sidebar_header_widget_weather_temperature
  const [citytemp, setcitytemp] = useState(
    props?.AllCustomization?.sidebar_header_widget_weather_temperature !==
      null &&
      props?.AllCustomization?.sidebar_header_widget_weather_temperature !==
        "N/A" &&
      props?.AllCustomization?.sidebar_header_widget_weather_temperature !== ""
      ? JSON.parse(
          props?.AllCustomization?.sidebar_header_widget_weather_temperature
        )
      : ""
  );

  const [data, setdata] = useState({
    sidebar_body_background_picture_status:
      props.AllCustomization.sidebar_body_background_picture_status,
    sidebar_body_background_picture_url:
      props.AllCustomization.sidebar_body_background_picture_url,
    file: null,

    sidebar_body_description_text_font_name:
      props.AllCustomization.sidebar_body_description_text_font_name,
    sidebar_body_description_text_font_name_options:
      props.AllCustomization.sidebar_body_description_text_font_name_options,

    //news options
    // sidebar_body_news_option_name: props.AllCustomization.sidebar_body_news_source,
    sidebar_body_news_options: props.newsSources,

    sidebar_body_description_text_size:
      props.AllCustomization.sidebar_body_description_text_size,
    sidebar_body_description_text_size_options:
      props.AllCustomization.sidebar_body_description_text_size_options,

    sidebar_body_title_text_font_name:
      props.AllCustomization.sidebar_body_title_text_font_name,
    sidebar_body_title_text_font_name_options:
      props.AllCustomization.sidebar_body_title_text_font_name_options,

    sidebar_body_title_text_size:
      props.AllCustomization.sidebar_body_title_text_size,
    sidebar_body_title_text_size_options:
      props.AllCustomization.sidebar_body_title_text_size_options,

    sidebar_header_main_area_font_name:
      props.AllCustomization.sidebar_header_main_area_font_name,
    sidebar_header_main_area_font_name_options:
      props.AllCustomization.sidebar_header_main_area_font_name_options,

    sidebar_header_main_area_text_size:
      props.AllCustomization.sidebar_header_main_area_text_size,
    sidebar_header_main_area_text_size_options:
      props.AllCustomization.sidebar_header_main_area_text_size_options,

    sidebar_body_background_color:
      props.AllCustomization.sidebar_body_background_color,
    sidebar_body_description_text_color:
      props.AllCustomization.sidebar_body_description_text_color,

    sidebar_body_title_text_color:
      props.AllCustomization.sidebar_body_title_text_color,
    sidebar_header_main_area_background_color:
      props.AllCustomization.sidebar_header_main_area_background_color,

    sidebar_header_main_area_text:
      props.AllCustomization.sidebar_header_main_area_text,

    sidebar_header_main_area_text_color:
      props.AllCustomization.sidebar_header_main_area_text_color,

    BodyBackgroundColorPicker: false,
    BodyDescriptionTextColorPicker: false,
    BodyTitleTextColorPicker: false,
    HeaderMainAreaBackgroundColorPicker: false,
    HeaderMainAreaTextColorPicker: false,

    sidebar_header_widget_clock_status:
      props.AllCustomization.sidebar_header_widget_clock_status,

    sidebar_header_widget_weather_status:
      props.AllCustomization.sidebar_header_widget_weather_status,
    sidebar_header_widget_weather_stats:
      props.AllCustomization.sidebar_header_widget_weather_stats,
    sidebar_header_widget_weather_temperature:
      props.AllCustomization.sidebar_header_widget_weather_temperature,

    sidebar_body_generic_status:
      props.AllCustomization.sidebar_body_generic_status,
    sidebar_body_widget_news_status:
      props.AllCustomization.sidebar_body_widget_news_status,
    sidebar_body_widget_rss_status:
      props.AllCustomization.sidebar_body_widget_rss_status,
    sidebar_body_widget_cricinfo_status:
      props.AllCustomization.sidebar_body_widget_cricinfo_status,

    postwidget:
      props.AllCustomization.sidebar_body_generic_status === true
        ? "GenericDescription"
        : props.AllCustomization.sidebar_body_widget_news_status === true
        ? "News"
        : props.AllCustomization.sidebar_body_widget_rss_status === true
        ? "RSS"
        : props.AllCustomization.sidebar_body_widget_cricinfo_status === true
        ? "Cricinfo"
        : "none",

    sidebar_body_generic_title:
      props.AllCustomization.sidebar_body_generic_title,
    sidebar_body_generic_description:
      props.AllCustomization.sidebar_body_generic_description,

    sidebar_body_rss_link: props.AllCustomization.sidebar_body_rss_link,

    sidebar_body_news_source: props.AllCustomization.sidebar_body_news_source,

    open: false,
  });

  const closeModal = () => {
    setdata((previousvalue) => ({
      ...previousvalue,
      open: false,
    }));
  };

  const OpenModal = async () => {
    if (
      data.postwidget === "GenericDescription" &&
      (data.sidebar_body_generic_description === "" ||
        data.sidebar_body_generic_title === "N/A")
    ) {
      toast.error("Description is empty or not changed");
    } else if (
      data.postwidget === "RSS" &&
      (data.sidebar_body_rss_link === "" ||
        data.sidebar_body_rss_link === "N/A")
    ) {
      toast.error("RSS Link is empty or changed");
    } else if (
      data.postwidget === "News" &&
      data.sidebar_body_news_source.length === 0
    ) {
      toast.error("Select atleast 1 news source");
    } else {
      setdata((previousvalue) => ({
        ...previousvalue,
        open: true,
      }));
    }
  };

  const styles = reactCSS({
    default: {
      popover: {
        position: "absolute",
        zIndex: "2",
        right: "0",
        marginTop: "52px",
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px",
      },
    },
  });

  const handleColorChangeComplete = (color, e) => {
    setdata({
      ...data,
      [e]: color.hex,
    });
  };
  const handleColorPickerOpen = (name) => {
    setdata({
      ...data,
      [name]: true,
    });
  };

  const handleClose = (name) => {
    setdata({
      ...data,
      [name]: false,
    });
  };

  //change sidebgimage
  const handleChangebgImg = async (file) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      file: file,
      sidebar_body_background_picture_url: URL.createObjectURL(file),
    }));
  };

  //change sidebgimagestatus
  const handleChangebgImgStatus = (event) => {
    setdata({
      ...data,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangedrop = (e, name) => {
    setdata({
      ...data,
      [name]: e,
    });
  };

  const handleNewsChangedrop = (e, name) => {
    if ((e != null) != null && e.length > 3) {
      toast.error("Cannot select more than 3 news sources");
    } else {
      setdata({
        ...data,
        [name]: e,
      });
    }
  };

  const handleChangeWidgets = (event) => {
    setdata({
      ...data,
      [event.target.name]: event.target.checked,
    });
  };

  const handleGenericDetails = (e) => {
    setdata({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleMainHeaderText = (e) => {
    if(e.target.value.length > 18){
      toast.error("Maximum limit of main text has reached.")
    }
    else{
    setdata({
      ...data,
      [e.target.name]: e.target.value,
    });
  }
  }

  /***FOR RSS link */
  const handleRSSLink = (e) => {
    setdata({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const handleBodyWidgets = (e) => {
    setdata({
      ...data,
      postwidget: e.target.value,
    });
  };

  const handleCustomizationUpdate = async () => {
    const Customizationdata = new FormData();
    switch (data.postwidget) {
      case "GenericDescription":
        Customizationdata.append("security_token", await GetCookie("es_token"));
        Customizationdata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );

        Customizationdata.append("txt_customization_type", "Sidebar");
        Customizationdata.append("sidebar_body_widget_news_status", "false");
        Customizationdata.append("sidebar_body_widget_rss_status", "false");
        Customizationdata.append(
          "sidebar_body_widget_cricinfo_status",
          "false"
        );
        Customizationdata.append("sidebar_body_generic_status", "true");
        Customizationdata.append(
          "sidebar_body_generic_title",
          data.sidebar_body_generic_title
        );
        Customizationdata.append(
          "sidebar_body_generic_description",
          data.sidebar_body_generic_description
        );

        Customizationdata.append(
          "sidebar_body_rss_link",
          data.sidebar_body_rss_link
        );

        Customizationdata.append("sidebar_body_news_source", "N/A");
        if (data.file) {
          Customizationdata.append("file", data.file);
        } else if (
          !data.file &&
          data.sidebar_body_background_picture_url === ""
        ) {
          Customizationdata.append(
            "sidebar_body_background_picture_url",
            "N/A"
          );
        } else {
          Customizationdata.append(
            "sidebar_body_background_picture_url",
            data.sidebar_body_background_picture_url
          );
        }
        Customizationdata.append(
          "sidebar_body_background_picture_status",
          data.sidebar_body_background_picture_status
        );
        Customizationdata.append(
          "sidebar_body_description_text_font_name",
          data.sidebar_body_description_text_font_name.value
        );
        Customizationdata.append(
          "sidebar_body_description_text_size",
          data.sidebar_body_description_text_size.value
        );
        Customizationdata.append(
          "sidebar_body_title_text_font_name",
          data.sidebar_body_title_text_font_name.value
        );
        Customizationdata.append(
          "sidebar_body_title_text_size",
          data.sidebar_body_title_text_size.value
        );
        Customizationdata.append(
          "sidebar_header_main_area_font_name",
          data.sidebar_header_main_area_font_name.value
        );
        Customizationdata.append(
          "sidebar_header_main_area_text_size",
          data.sidebar_header_main_area_text_size.value
        );
        Customizationdata.append(
          "sidebar_body_background_color",
          data.sidebar_body_background_color
        );
        Customizationdata.append(
          "sidebar_body_description_text_color",
          data.sidebar_body_description_text_color
        );
        Customizationdata.append(
          "sidebar_body_title_text_color",
          data.sidebar_body_title_text_color
        );
        Customizationdata.append(
          "sidebar_header_main_area_background_color",
          data.sidebar_header_main_area_background_color
        );
        Customizationdata.append(
          "sidebar_header_main_area_text_color",
          data.sidebar_header_main_area_text_color
        );

        Customizationdata.append(
          "sidebar_header_widget_clock_status",
          data.sidebar_header_widget_clock_status
        );

        Customizationdata.append(
          "sidebar_header_widget_weather_status",
          data.sidebar_header_widget_weather_status
        );

        if (data.sidebar_header_widget_weather_status) {
          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            selectedcity?.value
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_temperature",
            JSON.stringify(citytemp)
          );
        } else {
          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            "N/A"
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_temperature",
            "N/A"
          );
        }

        Customizationdata.append(
          "sidebar_header_main_area_text",
          data.sidebar_header_main_area_text
        );

        Customizationdata.append(
          "sidebar_body_widget_news_status",
          data.sidebar_body_widget_news_status
        );

        if (
          data.sidebar_body_generic_title === "" ||
          data.sidebar_body_generic_title === undefined ||
          data.sidebar_body_generic_title === null ||
          data.sidebar_body_generic_title === "N/A"
        ) {
          toast.error("Please add the title");
        } else if (
          data.sidebar_body_generic_description === "" ||
          data.sidebar_body_generic_description === undefined ||
          data.sidebar_body_generic_description === null ||
          data.sidebar_body_generic_description === "N/A"
        ) {
          toast.error("Please add the description");
        } else if (
          data.sidebar_header_widget_weather_status &&
          (selectedcity?.length === 0 ||
            selectedcity === undefined ||
            selectedcity === null ||
            selectedcity === "undefined" ||
            selectedcity === "null" ||
            citytemp === undefined ||
            citytemp === null ||
            citytemp === "undefined" ||
            citytemp === "null")
        ) {
          toast.error("Please Select the city");
        } else {
          updateinformation(Customizationdata);
        }
        break;
      case "News":
        if (
          data.sidebar_body_news_source !== null &&
          data.sidebar_body_news_source !== undefined &&
          data.sidebar_body_news_source.length > 0
        ) {
          Customizationdata.append(
            "security_token",
            await GetCookie("es_token")
          );
          Customizationdata.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          Customizationdata.append("txt_customization_type", "Sidebar");
          Customizationdata.append("sidebar_body_widget_news_status", "true");
          Customizationdata.append("sidebar_body_generic_status", "false");
          Customizationdata.append("sidebar_body_widget_rss_status", "false");
          Customizationdata.append(
            "sidebar_body_widget_cricinfo_status",
            "false"
          );
          Customizationdata.append(
            "sidebar_body_generic_title",
            data.sidebar_body_generic_title
          );
          Customizationdata.append(
            "sidebar_body_generic_description",
            data.sidebar_body_generic_description
          );

          Customizationdata.append(
            "sidebar_body_rss_link",
            data.sidebar_body_rss_link
          );

          // var formattedNewsNames = data.sidebar_body_news_source[0]["label"];
          // for (var i = 1; i < data.sidebar_body_news_source.length; i++) {
          //   formattedNewsNames =
          //     formattedNewsNames +
          //     "," +
          //     data.sidebar_body_news_source[i]["label"];//Issue Reported
          // }
          // SSBR USe this
          let formattedNewsNames = "";
          if (
            Array.isArray(data.sidebar_body_news_source) &&
            data.sidebar_body_news_source.length > 0
          ) {
            for (let i = 0; i < data.sidebar_body_news_source.length; i++) {
              const item = data.sidebar_body_news_source[i];
              if (item && typeof item === "object" && "label" in item) {
                formattedNewsNames += (formattedNewsNames ? "," : "") + item.label;
              }
            }
          }
          //SSBR End

          Customizationdata.append(
            "sidebar_body_news_source",
            formattedNewsNames
          );
          if (data.file) {
            Customizationdata.append("file", data.file);
          } else if (
            !data.file &&
            data.sidebar_body_background_picture_url === ""
          ) {
            Customizationdata.append(
              "sidebar_body_background_picture_url",
              "N/A"
            );
          } else {
            Customizationdata.append(
              "sidebar_body_background_picture_url",
              data.sidebar_body_background_picture_url
            );
          }
          Customizationdata.append(
            "sidebar_body_background_picture_status",
            data.sidebar_body_background_picture_status
          );
          Customizationdata.append(
            "sidebar_body_description_text_font_name",
            data.sidebar_body_description_text_font_name.value
          );
          Customizationdata.append(
            "sidebar_body_description_text_size",
            data.sidebar_body_description_text_size.value
          );
          Customizationdata.append(
            "sidebar_body_title_text_font_name",
            data.sidebar_body_title_text_font_name.value
          );
          Customizationdata.append(
            "sidebar_body_title_text_size",
            data.sidebar_body_title_text_size.value
          );
          Customizationdata.append(
            "sidebar_header_main_area_font_name",
            data.sidebar_header_main_area_font_name.value
          );

          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            data.sidebar_header_widget_weather_stats
          );

          if (data.sidebar_header_widget_weather_status) {
            Customizationdata.append(
              "sidebar_header_widget_weather_stats",
              selectedcity?.value
            );
            Customizationdata.append(
              "sidebar_header_widget_weather_temperature",
              JSON.stringify(citytemp)
            );
          } else {
            Customizationdata.append(
              "sidebar_header_widget_weather_stats",
              "N/A"
            );
            Customizationdata.append(
              "sidebar_header_widget_weather_temperature",
              "N/A"
            );
          }
          Customizationdata.append(
            "sidebar_header_main_area_text_size",
            data.sidebar_header_main_area_text_size.value
          );
          Customizationdata.append(
            "sidebar_body_background_color",
            data.sidebar_body_background_color
          );
          Customizationdata.append(
            "sidebar_body_description_text_color",
            data.sidebar_body_description_text_color
          );
          Customizationdata.append(
            "sidebar_body_title_text_color",
            data.sidebar_body_title_text_color
          );
          Customizationdata.append(
            "sidebar_header_main_area_background_color",
            data.sidebar_header_main_area_background_color
          );
          Customizationdata.append(
            "sidebar_header_main_area_text_color",
            data.sidebar_header_main_area_text_color
          );
          Customizationdata.append(
            "sidebar_header_widget_clock_status",
            data.sidebar_header_widget_clock_status
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_status",
            data.sidebar_header_widget_weather_status
          );
          Customizationdata.append(
            "sidebar_header_main_area_text",
            data.sidebar_header_main_area_text
          );
          Customizationdata.append(
            "sidebar_widget_news_status",
            data.sidebar_body_widget_news_status
          );

          if (
            data.sidebar_header_widget_weather_status &&
            (selectedcity?.length === 0 ||
              selectedcity === undefined ||
              selectedcity === null ||
              selectedcity === "undefined" ||
              selectedcity === "null" ||
              citytemp === undefined ||
              citytemp === null ||
              citytemp === "undefined" ||
              citytemp === "null")
          ) {
            toast.error("Please Select the city");
          } else {
            updateinformation(Customizationdata);
          }
        } else {
          toast.error("Select atleast 1 news source");
        }
        break;

      case "RSS":
        if (
          data.sidebar_body_rss_link !== null &&
          data.sidebar_body_rss_link !== undefined &&
          data.sidebar_body_rss_link !== "N/A"
        ) {
          var isLink = false;
          try {
            new URL(data.sidebar_body_rss_link);
            isLink = true; // valid URL
          } catch (error) {
            isLink = false; // invalid URL
          }

          if (isLink) {
            Customizationdata.append(
              "security_token",
              await GetCookie("es_token")
            );
            Customizationdata.append(
              "txt_customer_id",
              localStorage.getItem("txt_customer_id")
            );
            Customizationdata.append("txt_customization_type", "Sidebar");
            Customizationdata.append(
              "sidebar_body_widget_news_status",
              "false"
            );
            Customizationdata.append("sidebar_body_generic_status", "false");
            Customizationdata.append("sidebar_body_widget_rss_status", "true");
            Customizationdata.append(
              "sidebar_body_widget_cricinfo_status",
              "false"
            );
            Customizationdata.append(
              "sidebar_body_generic_title",
              data.sidebar_body_generic_title
            );
            Customizationdata.append(
              "sidebar_body_generic_description",
              data.sidebar_body_generic_description
            );

            Customizationdata.append(
              "sidebar_body_rss_link",
              data.sidebar_body_rss_link
            );

            Customizationdata.append("sidebar_body_news_source", "N/A");

            if (data.file) {
              Customizationdata.append("file", data.file);
            } else if (
              !data.file &&
              data.sidebar_body_background_picture_url === ""
            ) {
              Customizationdata.append(
                "sidebar_body_background_picture_url",
                "N/A"
              );
            } else {
              Customizationdata.append(
                "sidebar_body_background_picture_url",
                data.sidebar_body_background_picture_url
              );
            }
            Customizationdata.append(
              "sidebar_body_background_picture_status",
              data.sidebar_body_background_picture_status
            );
            Customizationdata.append(
              "sidebar_body_description_text_font_name",
              data.sidebar_body_description_text_font_name.value
            );
            Customizationdata.append(
              "sidebar_body_description_text_size",
              data.sidebar_body_description_text_size.value
            );
            Customizationdata.append(
              "sidebar_body_title_text_font_name",
              data.sidebar_body_title_text_font_name.value
            );
            Customizationdata.append(
              "sidebar_body_title_text_size",
              data.sidebar_body_title_text_size.value
            );
            Customizationdata.append(
              "sidebar_header_main_area_font_name",
              data.sidebar_header_main_area_font_name.value
            );

            Customizationdata.append(
              "sidebar_header_widget_weather_stats",
              data.sidebar_header_widget_weather_stats
            );

            if (data.sidebar_header_widget_weather_status) {
              Customizationdata.append(
                "sidebar_header_widget_weather_stats",
                selectedcity?.value
              );
              Customizationdata.append(
                "sidebar_header_widget_weather_temperature",
                JSON.stringify(citytemp)
              );
            } else {
              Customizationdata.append(
                "sidebar_header_widget_weather_stats",
                "N/A"
              );
              Customizationdata.append(
                "sidebar_header_widget_weather_temperature",
                "N/A"
              );
            }
            Customizationdata.append(
              "sidebar_header_main_area_text_size",
              data.sidebar_header_main_area_text_size.value
            );
            Customizationdata.append(
              "sidebar_body_background_color",
              data.sidebar_body_background_color
            );
            Customizationdata.append(
              "sidebar_body_description_text_color",
              data.sidebar_body_description_text_color
            );
            Customizationdata.append(
              "sidebar_body_title_text_color",
              data.sidebar_body_title_text_color
            );
            Customizationdata.append(
              "sidebar_header_main_area_background_color",
              data.sidebar_header_main_area_background_color
            );
            Customizationdata.append(
              "sidebar_header_main_area_text_color",
              data.sidebar_header_main_area_text_color
            );
            Customizationdata.append(
              "sidebar_header_widget_clock_status",
              data.sidebar_header_widget_clock_status
            );
            Customizationdata.append(
              "sidebar_header_widget_weather_status",
              data.sidebar_header_widget_weather_status
            );
            Customizationdata.append(
              "sidebar_header_main_area_text",
              data.sidebar_header_main_area_text
            );
            Customizationdata.append(
              "sidebar_widget_news_status",
              data.sidebar_body_widget_news_status
            );

            if (
              data.sidebar_header_widget_weather_status &&
              (selectedcity?.length === 0 ||
                selectedcity === undefined ||
                selectedcity === null ||
                selectedcity === "undefined" ||
                selectedcity === "null" ||
                citytemp === undefined ||
                citytemp === null ||
                citytemp === "undefined" ||
                citytemp === "null")
            ) {
              toast.error("Please Select the city");
            } else {
              updateinformation(Customizationdata);
            }
          } else {
            toast.error("Please provide a valid link");
          }
        } else {
          toast.error("RSS link is missing");
        }
        break;

      case "Cricinfo":
        Customizationdata.append("security_token", await GetCookie("es_token"));
        Customizationdata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        Customizationdata.append("txt_customization_type", "Sidebar");
        Customizationdata.append("sidebar_body_widget_news_status", "false");
        Customizationdata.append("sidebar_body_generic_status", "false");
        Customizationdata.append("sidebar_body_widget_rss_status", "false");
        Customizationdata.append("sidebar_body_widget_cricinfo_status", "true");
        Customizationdata.append(
          "sidebar_body_generic_title",
          data.sidebar_body_generic_title
        );
        Customizationdata.append(
          "sidebar_body_generic_description",
          data.sidebar_body_generic_description
        );

        Customizationdata.append("sidebar_body_rss_link", "N/A");

        Customizationdata.append("sidebar_body_news_source", "N/A");
        if (data.file) {
          Customizationdata.append("file", data.file);
        } else if (
          !data.file &&
          data.sidebar_body_background_picture_url === ""
        ) {
          Customizationdata.append(
            "sidebar_body_background_picture_url",
            "N/A"
          );
        } else {
          Customizationdata.append(
            "sidebar_body_background_picture_url",
            data.sidebar_body_background_picture_url
          );
        }
        Customizationdata.append(
          "sidebar_body_background_picture_status",
          data.sidebar_body_background_picture_status
        );
        Customizationdata.append(
          "sidebar_body_description_text_font_name",
          data.sidebar_body_description_text_font_name.value
        );
        Customizationdata.append(
          "sidebar_body_description_text_size",
          data.sidebar_body_description_text_size.value
        );
        Customizationdata.append(
          "sidebar_body_title_text_font_name",
          data.sidebar_body_title_text_font_name.value
        );
        Customizationdata.append(
          "sidebar_body_title_text_size",
          data.sidebar_body_title_text_size.value
        );
        Customizationdata.append(
          "sidebar_header_main_area_font_name",
          data.sidebar_header_main_area_font_name.value
        );

        Customizationdata.append(
          "sidebar_header_widget_weather_stats",
          data.sidebar_header_widget_weather_stats
        );

        if (data.sidebar_header_widget_weather_status) {
          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            selectedcity?.value
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_temperature",
            JSON.stringify(citytemp)
          );
        } else {
          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            "N/A"
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_temperature",
            "N/A"
          );
        }
        Customizationdata.append(
          "sidebar_header_main_area_text_size",
          data.sidebar_header_main_area_text_size.value
        );
        Customizationdata.append(
          "sidebar_body_background_color",
          data.sidebar_body_background_color
        );
        Customizationdata.append(
          "sidebar_body_description_text_color",
          data.sidebar_body_description_text_color
        );
        Customizationdata.append(
          "sidebar_body_title_text_color",
          data.sidebar_body_title_text_color
        );
        Customizationdata.append(
          "sidebar_header_main_area_background_color",
          data.sidebar_header_main_area_background_color
        );
        Customizationdata.append(
          "sidebar_header_main_area_text_color",
          data.sidebar_header_main_area_text_color
        );
        Customizationdata.append(
          "sidebar_header_widget_clock_status",
          data.sidebar_header_widget_clock_status
        );
        Customizationdata.append(
          "sidebar_header_widget_weather_status",
          data.sidebar_header_widget_weather_status
        );
        Customizationdata.append(
          "sidebar_header_main_area_text",
          data.sidebar_header_main_area_text
        );
        Customizationdata.append(
          "sidebar_widget_news_status",
          data.sidebar_body_widget_news_status
        );

        if (
          data.sidebar_header_widget_weather_status &&
          (selectedcity?.length === 0 ||
            selectedcity === undefined ||
            selectedcity === null ||
            selectedcity === "undefined" ||
            selectedcity === "null" ||
            citytemp === undefined ||
            citytemp === null ||
            citytemp === "undefined" ||
            citytemp === "null")
        ) {
          toast.error("Please Select the city");
        } else {
          updateinformation(Customizationdata);
        }
        break;

      case "none":
        Customizationdata.append("security_token", await GetCookie("es_token"));
        Customizationdata.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );

        Customizationdata.append("txt_customization_type", "Sidebar");
        Customizationdata.append("sidebar_body_widget_news_status", "false");
        Customizationdata.append("sidebar_body_generic_status", "false");
        Customizationdata.append("sidebar_body_widget_rss_status", "false");
        Customizationdata.append(
          "sidebar_body_widget_cricinfo_status",
          "false"
        );
        Customizationdata.append(
          "sidebar_body_generic_title",
          data.sidebar_body_generic_title
        );
        Customizationdata.append(
          "sidebar_body_generic_description",
          data.sidebar_body_generic_description
        );

        Customizationdata.append(
          "sidebar_body_rss_link",
          data.sidebar_body_rss_link
        );

        Customizationdata.append("sidebar_body_news_source", "N/A");

        if (data.file) {
          Customizationdata.append("file", data.file);
        } else if (
          !data.file &&
          data.sidebar_body_background_picture_url === ""
        ) {
          Customizationdata.append(
            "sidebar_body_background_picture_url",
            "N/A"
          );
        } else {
          Customizationdata.append(
            "sidebar_body_background_picture_url",
            data.sidebar_body_background_picture_url
          );
        }
        Customizationdata.append(
          "sidebar_body_background_picture_status",
          data.sidebar_body_background_picture_status
        );
        Customizationdata.append(
          "sidebar_body_description_text_font_name",
          data.sidebar_body_description_text_font_name.value
        );
        Customizationdata.append(
          "sidebar_body_description_text_size",
          data.sidebar_body_description_text_size.value
        );
        Customizationdata.append(
          "sidebar_body_title_text_font_name",
          data.sidebar_body_title_text_font_name.value
        );
        Customizationdata.append(
          "sidebar_body_title_text_size",
          data.sidebar_body_title_text_size.value
        );
        Customizationdata.append(
          "sidebar_header_main_area_font_name",
          data.sidebar_header_main_area_font_name.value
        );
        Customizationdata.append(
          "sidebar_header_main_area_text_size",
          data.sidebar_header_main_area_text_size.value
        );

        Customizationdata.append(
          "sidebar_body_background_color",
          data.sidebar_body_background_color
        );
        Customizationdata.append(
          "sidebar_body_description_text_color",
          data.sidebar_body_description_text_color
        );
        Customizationdata.append(
          "sidebar_body_title_text_color",
          data.sidebar_body_title_text_color
        );
        Customizationdata.append(
          "sidebar_header_main_area_background_color",
          data.sidebar_header_main_area_background_color
        );
        Customizationdata.append(
          "sidebar_header_main_area_text_color",
          data.sidebar_header_main_area_text_color
        );

        Customizationdata.append(
          "sidebar_header_widget_clock_status",
          data.sidebar_header_widget_clock_status
        );
        Customizationdata.append(
          "sidebar_header_widget_weather_status",
          data.sidebar_header_widget_weather_status
        );

        if (data.sidebar_header_widget_weather_status) {
          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            selectedcity?.value
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_temperature",
            JSON.stringify(citytemp)
          );
        } else {
          Customizationdata.append(
            "sidebar_header_widget_weather_stats",
            "N/A"
          );
          Customizationdata.append(
            "sidebar_header_widget_weather_temperature",
            "N/A"
          );
        }
        Customizationdata.append(
          "sidebar_header_main_area_text",
          data.sidebar_header_main_area_text
        );
        Customizationdata.append(
          "sidebar_widget_news_status",
          data.sidebar_body_widget_news_status
        );
        if (
          data.sidebar_header_widget_weather_status &&
          (selectedcity?.length === 0 ||
            selectedcity === undefined ||
            selectedcity === null ||
            selectedcity === "undefined" ||
            selectedcity === "null" ||
            citytemp === undefined ||
            citytemp === null ||
            citytemp === "undefined" ||
            citytemp === "null")
        ) {
          toast.error("Please Select the city");
        } else {
          updateinformation(Customizationdata);
        }
        break;
      default:
        toast.error("Something went wrong");
        break;
    }
  };

  const handleChangeCityname = async (e) => {
    setcityvalue(e);
    if (e.length === 4) {
      try {
        const payload = new FormData();
        payload.append(
          "txt_customer_id",
          localStorage.getItem("txt_customer_id")
        );
        payload.append("security_token", await GetCookie("es_token"));
        payload.append("txt_city_name", e);
        const res = await cities(payload).unwrap();
        if (
          res.connection === "true" &&
          res.status === "true" &&
          res.message === "Location available"
        ) {
          setcitylist(res.data);
        } else if (
          res.connection === "true" &&
          res.status === "false" &&
          res.message === "No location available"
        ) {
          setcitylist([]);
          toast.info(res.message);
        } else {
          toast.error(res.message);
          setcitylist([]);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleCityChange = async (e) => {
    setselectedcity(e);
    if (
      e !== null &&
      e !== undefined &&
      e !== "" &&
      e !== "null" &&
      e !== "undefined"
    ) {
      if (
        e.value !== null ||
        e.value !== undefined ||
        e.value !== "" ||
        e.value !== "null" ||
        e.value !== "undefined"
      ) {
        try {
          const payload = new FormData();
          payload.append(
            "txt_customer_id",
            localStorage.getItem("txt_customer_id")
          );
          payload.append("security_token", await GetCookie("es_token"));
          payload.append("txt_location", e.value);
          const res = await Weather(payload).unwrap();
          if (
            res.connection === "true" &&
            res.status === "true" &&
            res.message === "Weather details updated" &&
            res.data !== ""
          ) {
            const parseddata = JSON.parse(res.data);
            setcitytemp(parseddata);
          } else if (
            res.connection === "true" &&
            res.status === "true" &&
            res.message === "Weather details updated" &&
            res.data === ""
          ) {
            setcitytemp(null);
            toast.info("NO UPDATE");
          } else {
            toast.error(res.message);
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
  };

  const handleRSSNews = async (data) => {
    try {
      const res = await getRSSNewsSources(data).unwrap();

      setRssNewsFromLink(JSON.stringify(res));

      setdata((previousvalue) => ({
        ...previousvalue,
        open: true,
      }));
    } catch (error) {
      toast.error(error.status);
    }
  };
  const handleReceivedNews = async (data) => {
    try {
      const res = await getNewsSources(data).unwrap();

      setNewsFromSources(res);
    } catch (error) {
      toast.error(error.status);
    }
  };

  const updateinformation = async (data) => {
    try {
      const res = await updatecustomization(data).unwrap();
      if (
        res.connection === "true" &&
        res.status === "true" &&
        res.message === "Sidebar information updated successfully"
      ) {
        toast.success(res.message);
        props.getCustomWidgets();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.status);
    }
  };

  return (
    <>
      <Box paddingLeft={3} paddingRight={3}>
        <div className="row g-0">
          <div className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-start mr-0 px-0">
            <span
              style={{ color: "black", fontWeight: "bold", fontSize: "25px" }}
            >
              Sidebar Customization
            </span>
          </div>
          <div className="col col-sm-6 col-md-6 col-lg-6 d-flex justify-content-end mr-0 px-0">
            <Button
              variant="contained"
              sx={{ maxHeight: "40px" }}
              onClick={handleCustomizationUpdate}
              className="capitalized fs-14 fw-bold"
            >
              Save & Post
            </Button>
          </div>
          <Divider />
        </div>

        <div className="row">
          <h3
            className="mt-4"
            style={{
              color: "black",
              fontWeight: "bold",
              fontSize: "20px",
              opacity: "87%",
            }}
          >
            Header Styling
          </h3>

          <div className="form-group col-md-6">
            <FormControl component="fieldset">
              <FormLabel component="legend">Header Widgets</FormLabel>
              <FormGroup aria-label="position" row>
                <div
                  style={{
                    backgroundColor: data.sidebar_header_widget_clock_status
                      ? "#E6F0FD"
                      : "#E8E8E8",
                    border: data.sidebar_header_widget_clock_status
                      ? "1px solid #1776EE"
                      : "#E8E8E8",
                    borderRadius: "8px",
                    paddingLeft: "13px",
                    marginRight: "10px",
                  }}
                >
                  <FormControlLabel
                    value="Clock"
                    control={<Checkbox size="small" />}
                    label="Clock"
                    labelPlacement="end"
                    name="sidebar_header_widget_clock_status"
                    onChange={handleChangeWidgets}
                    checked={data.sidebar_header_widget_clock_status}
                  />
                </div>
                <div
                  style={{
                    backgroundColor: data.sidebar_header_widget_weather_status
                      ? "#E6F0FD"
                      : "#E8E8E8",
                    borderRadius: "8px",
                    border: data.sidebar_header_widget_weather_status
                      ? "1px solid #1776EE"
                      : "#E8E8E8",
                    paddingLeft: "13px",
                    marginRight: "10px",
                  }}
                >
                  <FormControlLabel
                    value="Weather"
                    control={<Checkbox size="small" />}
                    label="Weather"
                    labelPlacement="end"
                    name="sidebar_header_widget_weather_status"
                    checked={data.sidebar_header_widget_weather_status}
                    onChange={handleChangeWidgets}
                  />
                </div>
              </FormGroup>
            </FormControl>
          </div>
          <div className="form-group col-md-6">
            {data.sidebar_header_widget_weather_status ? (
              <div className="row">
                <div className="form-group col-md-6">
                  <label htmlFor="inputEmail4" className="sidebarlabels">
                    Select City
                  </label>
                  <Select
                    options={citylist}
                    value={selectedcity}
                    onChange={handleCityChange}
                    onInputChange={handleChangeCityname}
                    inputValue={cityvalue}
                    isClearable={true}
                    isLoading={isLoading}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </div>
                <div className="form-group col-md-6">
                  <label htmlFor="inputEmail4" className="sidebarlabels">
                    Temprature
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Temp"
                    aria-label="Temp"
                    aria-describedby="basic-addon2"
                    readOnly={true}
                    value={
                      citytemp ? citytemp?.current?.feelslike_c + "C" : "0C"
                    }
                  />
                </div>
              </div>
            ) : null}
          </div>

          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Main Area Font Name
            </label>
            <Select
              options={data.sidebar_header_main_area_font_name_options}
              value={data.sidebar_header_main_area_font_name}
              onChange={(e) =>
                handleChangedrop(e, "sidebar_header_main_area_font_name")
              }
              name="sidebar_header_main_area_font_name"
              isClearable={true}
              placeholder="Header Main Area Font Name"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>

          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Main Area Text Size
            </label>
            <Select
              options={data.sidebar_header_main_area_text_size_options}
              value={data.sidebar_header_main_area_text_size}
              name="sidebar_header_main_area_text_size"
              onChange={(e) =>
                handleChangedrop(e, "sidebar_header_main_area_text_size")
              }
              isClearable={true}
              placeholder="Header Main Area Text Size"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Main Area Background Color
            </label>
            <div className="input-group ">
              <input
                type="text"
                className="form-control inputheight"
                placeholder="Header Main Area Background Color"
                aria-label="Header Main Area Background Color"
                aria-describedby="basic-addon2"
                value={data.sidebar_header_main_area_background_color}
                readOnly={true}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  id="basic-addon2"
                  style={{
                    borderRadius: "0px",
                    backgroundColor:
                      data.sidebar_header_main_area_background_color,
                    height: "38.48px",
                  }}
                ></span>
              </div>
              <div>
                {data.HeaderMainAreaBackgroundColorPicker ? (
                  <div style={styles.popover}>
                    <div
                      style={styles.cover}
                      onClick={() =>
                        handleClose("HeaderMainAreaBackgroundColorPicker")
                      }
                    />
                    <SketchPicker
                      color={data.sidebar_header_main_area_background_color}
                      onChange={(e) =>
                        handleColorChangeComplete(
                          e,
                          "sidebar_header_main_area_background_color"
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
              <div className="input-group-append">
                <span
                  className="input-group-text inputheight"
                  id="basic-addon2"
                  style={{ borderRadius: "0px" }}
                >
                  <Button
                    onClick={() =>
                      handleColorPickerOpen(
                        "HeaderMainAreaBackgroundColorPicker"
                      )
                    }
                    className="capitalized fs-14 fw-bold"
                  >
                    Open
                  </Button>
                </span>
              </div>
            </div>
          </div>

          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Main Area Text Color
            </label>
            <div className="input-group ">
              <input
                type="text"
                className="form-control inputheight"
                placeholder="Header Main Area Text Color"
                aria-label="Header Main Area Text Color"
                aria-describedby="basic-addon2"
                value={data.sidebar_header_main_area_text_color}
                readOnly={true}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  id="basic-addon2"
                  style={{
                    borderRadius: "0px",
                    backgroundColor: data.sidebar_header_main_area_text_color,
                    height: "38.48px",
                  }}
                ></span>
              </div>
              <div>
                {/*
<div className="row">
<div className="form-group col-md-6 mt-3">
<label htmlFor="inputEmail4" className="sidebarlabels">
  Main Area Text
</label>

<textarea
        value={data?.sidebar_header_main_area_text}
        name="sidebar_header_main_area_text"
        onChange={(e) => handleGenericDetails(e)}
      />
</div>
</div> */}

                {data.HeaderMainAreaTextColorPicker ? (
                  <div style={styles.popover}>
                    <div
                      style={styles.cover}
                      onClick={() =>
                        handleClose("HeaderMainAreaTextColorPicker")
                      }
                    />
                    <SketchPicker
                      color={data.sidebar_header_main_area_text_color}
                      onChange={(e) =>
                        handleColorChangeComplete(
                          e,
                          "sidebar_header_main_area_text_color"
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
              <div className="input-group-append ">
                <span
                  className="input-group-text inputheight"
                  id="basic-addon2"
                  style={{ borderRadius: "0px" }}
                >
                  <Button
                    onClick={() =>
                      handleColorPickerOpen("HeaderMainAreaTextColorPicker")
                    }
                    className="capitalized fs-14 fw-bold"
                  >
                    Open
                  </Button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Main Area Text
            </label>

            <textarea
              value={data?.sidebar_header_main_area_text}
              name="sidebar_header_main_area_text"
              onChange={(e) => handleMainHeaderText(e)}
            />
          </div>
        </div>

        <h3
          className="mt-5 mb-4"
          style={{
            color: "black",
            fontWeight: "bold",
            fontSize: "20px",
            opacity: "87%",
          }}
        >
          Body Styling
        </h3>
        <div className="row">
          <div className="form-group col-md-6 ">
            <div className="row">
              <div className="form-group col-md-5 w-10">
                <div className="sidebarbackgroundimgcustomization">
                  <FileUploader
                    handleChange={handleChangebgImg}
                    name="file"
                    types={fileTypes}
                  />
                </div>
              </div>
              <div className="form-group col-md-1 mt-3 w-2 d-flex justify-content-center align-items-center">
                <img
                  src={data.sidebar_body_background_picture_url}
                  alt="img"
                  width="50px"
                  height="50px"
                  style={{ borderRadius: "8px", objectFit: "contain" }}
                />
              </div>
            </div>

            <p className="mt-1" style={{ fontSize: "14px" }}>
              152 * 152 Size JPG or PNG is recommended
            </p>
          </div>
          <div className="form-group col-md-6 col-lg-6">
            <FormControl component="fieldset">
              <FormLabel component="legend">Background Image Status</FormLabel>
              <FormGroup aria-label="position" row>
                <FormControlLabel
                  value="start"
                  control={<Switch color="primary" />}
                  label="Show Background Image"
                  labelPlacement="start"
                  name="sidebar_body_background_picture_status"
                  onChange={handleChangebgImgStatus}
                  checked={data.sidebar_body_background_picture_status}
                />
              </FormGroup>
            </FormControl>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-8">
            <FormControl component="fieldset">
              <FormLabel
                id="demo-row-radio-buttons-group-label"
                component="legend"
              >
                <h3
                  className="mt-4"
                  style={{
                    color: "black",
                    fontWeight: "bold",
                    fontSize: "20px",
                    opacity: "87%",
                  }}
                >
                  Widgets
                </h3>
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                value={data.postwidget}
                onChange={handleBodyWidgets}
              >
                <FormControlLabel
                  value="GenericDescription"
                  control={<Radio />}
                  label="Generic Description"
                />
                <FormControlLabel
                  value="News"
                  control={<Radio />}
                  label="News"
                />
                <FormControlLabel value="RSS" control={<Radio />} label="RSS" />
                <FormControlLabel
                  value="Cricinfo"
                  control={<Radio />}
                  label="Cricinfo"
                />
                <FormControlLabel
                  value="none"
                  control={<Radio />}
                  label="None"
                />
                {data.postwidget === "none" ? null : (
                  <Button onClick={OpenModal} className="capitalized fs-14 fw-bold">Live View</Button>
                )}
              </RadioGroup>
            </FormControl>
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6 col-lg-6">
            {data.postwidget === "GenericDescription" ? (
              <FormControl component="fieldset">
                {/* <FormLabel component="legend">
                  Generic Description
                </FormLabel> */}
                <FormGroup aria-label="position" row>
                  <label htmlFor="inputEmail4">Sidebar Generic Title</label>
                  <textarea
                    value={data?.sidebar_body_generic_title}
                    name="sidebar_body_generic_title"
                    onChange={(e) => handleGenericDetails(e)}
                  />
                  <label htmlFor="inputEmail4">
                    Sidebar Generic Description
                  </label>
                  <textarea
                    name="sidebar_body_generic_description"
                    value={data?.sidebar_body_generic_description}
                    onChange={(e) => handleGenericDetails(e)}
                  />
                </FormGroup>
              </FormControl>
            ) : data.postwidget === "RSS" ? (
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <label htmlFor="inputEmail4">RSS Link</label>
                  <textarea
                    value={data?.sidebar_body_rss_link}
                    name="sidebar_body_rss_link"
                    onChange={(e) => handleRSSLink(e)}
                  />
                </FormGroup>
              </FormControl>
            ) : data.postwidget === "News" ? (
              <FormControl component="fieldset">
                <FormGroup aria-label="position" row>
                  <Select
                    options={data.sidebar_body_news_options}
                    value={data.sidebar_body_news_source}
                    onChange={(e) =>
                      handleNewsChangedrop(e, "sidebar_body_news_source")
                    }
                    onClose={() => {
                      toast.error("close");
                    }}
                    name="sidebar_body_news_source"
                    isClearable={true}
                    placeholder="News options"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isMulti="true"
                    styles={{
                      menuPortal: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 9999,
                      }),
                    }}
                  />
                </FormGroup>
              </FormControl>
            ) : null}
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Description Text Font Name
            </label>
            <Select
              options={data.sidebar_body_description_text_font_name_options}
              value={data.sidebar_body_description_text_font_name}
              onChange={(e) =>
                handleChangedrop(e, "sidebar_body_description_text_font_name")
              }
              name="sidebar_body_description_text_font_name"
              isClearable={true}
              placeholder="Body Description Text Font Name"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>

          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Description Text Size
            </label>
            <Select
              options={data.sidebar_body_description_text_size_options}
              value={data.sidebar_body_description_text_size}
              name="sidebar_body_description_text_size"
              onChange={(e) =>
                handleChangedrop(e, "sidebar_body_description_text_size")
              }
              isClearable={true}
              placeholder="Body Description Text Size"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Title Text Font Name
            </label>

            <Select
              options={data.sidebar_body_title_text_font_name_options}
              value={data.sidebar_body_title_text_font_name}
              onChange={(e) =>
                handleChangedrop(e, "sidebar_body_title_text_font_name")
              }
              name="sidebar_body_title_text_font_name"
              isClearable={true}
              placeholder="Body Title Text Font Name"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>

          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Title Text Size
            </label>

            <Select
              options={data.sidebar_body_title_text_size_options}
              value={data.sidebar_body_title_text_size}
              onChange={(e) =>
                handleChangedrop(e, "sidebar_body_title_text_size")
              }
              name="sidebar_body_title_text_size"
              isClearable={true}
              placeholder="Body Title Text Size"
              menuPortalTarget={document.body}
              menuPosition="fixed"
              styles={{
                menuPortal: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
                menu: (provided) => ({
                  ...provided,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Background Color
            </label>
            <div className="input-group ">
              <input
                type="text"
                className="form-control inputheight"
                placeholder="Body Background Color"
                aria-label="Body Background Color"
                aria-describedby="basic-addon2"
                value={data.sidebar_body_background_color}
                readOnly={true}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  id="basic-addon2"
                  style={{
                    borderRadius: "0px",
                    backgroundColor: data.sidebar_body_background_color,
                    height: "38.48px",
                  }}
                ></span>
              </div>
              <div>
                {data.BodyBackgroundColorPicker ? (
                  <div style={styles.popover}>
                    <div
                      style={styles.cover}
                      onClick={() => handleClose("BodyBackgroundColorPicker")}
                    />
                    <SketchPicker
                      color={data.sidebar_body_background_color}
                      onChange={(e) =>
                        handleColorChangeComplete(
                          e,
                          "sidebar_body_background_color"
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
              <div className="input-group-append">
                <span
                  className="input-group-text inputheight"
                  id="basic-addon2"
                  style={{ borderRadius: "0px" }}
                >
                  <Button
                    onClick={() =>
                      handleColorPickerOpen("BodyBackgroundColorPicker")
                    }
                    className="capitalized fs-14 fw-bold"
                  >
                    Open
                  </Button>
                </span>
              </div>
            </div>
          </div>

          <div className="form-group col-md-6 mt-3">
            <label htmlFor="inputEmail4" className="sidebarlabels">
              Title Text Color
            </label>
            <div className="input-group ">
              <input
                type="text"
                className="form-control inputheight"
                placeholder="Body Title Text Color"
                aria-label="Body Title Text Color"
                aria-describedby="basic-addon2"
                value={data.sidebar_body_title_text_color}
                readOnly={true}
              />
              <div className="input-group-append">
                <span
                  className="input-group-text"
                  id="basic-addon2"
                  style={{
                    borderRadius: "0px",
                    backgroundColor: data.sidebar_body_title_text_color,
                    height: "38.48px",
                  }}
                ></span>
              </div>
              <div>
                {data.BodyTitleTextColorPicker ? (
                  <div style={styles.popover}>
                    <div
                      style={styles.cover}
                      onClick={() => handleClose("BodyTitleTextColorPicker")}
                    />
                    <SketchPicker
                      color={data.sidebar_body_title_text_color}
                      onChange={(e) =>
                        handleColorChangeComplete(
                          e,
                          "sidebar_body_title_text_color"
                        )
                      }
                    />
                  </div>
                ) : null}
              </div>
              <div className="input-group-append">
                <span
                  className="input-group-text inputheight"
                  id="basic-addon2"
                  style={{ borderRadius: "0px" }}
                >
                  <Button
                    onClick={() =>
                      handleColorPickerOpen("BodyTitleTextColorPicker")
                    }
                    className="capitalized fs-14 fw-bold"
                  >
                    Open
                  </Button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <Modal
          open={data.open}
          onClose={closeModal}
          classNames={{
            overlayAnimationIn: "customEnterOverlayAnimation",
            overlayAnimationOut: "customLeaveOverlayAnimation",
            modalAnimationIn: "customEnterModalAnimation",
            modalAnimationOut: "customLeaveModalAnimation",
          }}
          animationDuration={800}
          styles={{
            modal: {
              width: "90%",
              height: "50%",
              padding: "unset",
              overflow: "hidden",
            },
            overlay: {
              background: "rgba(0, 0, 0, 0.5)",
            },
            closeButton: {
              background: "yellow",
            },
          }}
          center
        >
          {data.postwidget === "GenericDescription" ? (
            <marquee direction="up" style={{ height: "100%" }}>
              <div>
                <div>{data.sidebar_body_generic_title}</div>
                <div>{data.sidebar_body_generic_description}</div>
              </div>
            </marquee>
          ) : data.postwidget === "News" ? (
            <div style={{ height: "100%" }}>
              <iframe
                src={BASEURL + "iframes/sidebar/news.html"}
                width="100%"
                height="100%"
                title="News"
              ></iframe>
            </div>
          ) : // <div style={{ height: "100%" }}>
          //   <marquee direction="up" style={{ height: "100%" }}>
          //     <div
          //       dangerouslySetInnerHTML={{
          //         __html: newsFromSources,
          //       }}
          //       style={{ height: "100%" }}
          //     />
          //   </marquee>
          // </div>
          data.postwidget === "Cricinfo" ? (
            <div style={{ height: "100%" }}>
              <iframe
                src={BASEURL + "iframes/sidebar/cricinfo.html"}
                width="100%"
                height="100%"
                title="News"
              ></iframe>
            </div>
          ) : data.postwidget === "RSS" ? (
            <div style={{ height: "100%" }}>
              <iframe
                src={
                  BASEURL +
                  "iframes/sidebar/rss.html?rssUrl=" +
                  data.sidebar_body_rss_link
                }
                width="100%"
                height="100%"
                title="News"
              ></iframe>
            </div>
          ) : // <div style={{ height: "100%" }}>
          //   <marquee direction="up" style={{ height: "100%" }}>
          //     {console.log("test2 =" + rssNewsFromLink)}

          //     <div
          //       dangerouslySetInnerHTML={{
          //         __html: rssNewsFromLink,
          //       }}
          //       style={{ height: "100%" }}
          //     />
          //   </marquee>
          // </div>

          null}
        </Modal>
      </Box>
    </>
  );
};

export default memo(ScreenSidebarCustomization);
